import { render, staticRenderFns } from "./innerLoader.vue?vue&type=template&id=cdebda24&scoped=true"
var script = {}
import style0 from "./innerLoader.vue?vue&type=style&index=0&id=cdebda24&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdebda24",
  null
  
)

export default component.exports